import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesAdmin() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Cobranza", items: [
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonos", desc: "Pagos recibidos", enabled: !!user.abonos },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuenta", desc: "Saldos de clientes", enabled: !!user.edoCtaClientes },
    ]},
    { section: "Ventas", items: [
      { label: "Ventas", icon: "fas fa-money-bill-wave", color: "#10b981", href: "/ListadoVentas", desc: "Listado de ventas", enabled: !!user.menu_ventas },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesAdmin", desc: "Devoluciones", enabled: !!user.menu_devolucionesAdmin },
    ]},
    { section: "Cuentas", items: [
      { label: "Anticipos", icon: "fas fa-hand-holding-usd", color: "#14b8a6", href: "/ListadoAnticipos", desc: "Anticipos de clientes", enabled: !!user.menuAnticipos },
      { label: "Saldo Inicial", icon: "fas fa-money-check-alt", color: "#64748b", href: "/ListadoSaldoInicial", desc: "Saldos iniciales", enabled: !!user.notasCargo },
      { label: "Comisiones", icon: "fas fa-percentage", color: "#8b5cf6", href: "/ListadoComisiones", desc: "Comisiones de vendedores", enabled: !!user.comisiones },
    ]},
    { section: "Bancos", items: [
      { label: "Bancos", icon: "fas fa-university", color: "#3b82f6", href: "/Bancos", desc: "Cuentas bancarias", enabled: !!user.bancos },
      { label: "Movimientos Bancos", icon: "fas fa-list-ol", color: "#3b82f6", href: "/MovimientosBancos", desc: "Movimientos", enabled: !!user.bancos },
      { label: "Empresas", icon: "fas fa-industry", color: "#64748b", href: "/Empresas", desc: "Razones sociales", enabled: !!user.menu_empresas },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Admin"
      descripcion="Cobranza, cuentas y bancos"
      icono="fas fa-file-invoice-dollar"
      color="#6366f1"
      secciones={SECCIONES}
    />
  );
}

export default BotonesAdmin;
